import { memo } from 'react';

import { CircularProgress } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';

// ----------------------------------------------------------------------

const SplashScreen = memo(({ sx, ...other }: BoxProps) => (
  <Box
    sx={{
      right: 0,
      width: 1,
      bottom: 0,
      height: '100vh',
      zIndex: 500,
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
      ...sx,
    }}
    {...other}
  >
    <CircularProgress
      size={80}
      sx={{
        '& circle': {
          color: '#214983',
          animationDuration: '1s !important',
        },
      }}
    />
  </Box>
));

export default SplashScreen;
